import { dispatch } from 'rfx-core';

import Form from './_.extend';

class AuthForm extends Form {
  hooks = () => ({
    async onSuccess(form) {
      try {
        let isOTP = false;
        const res = await dispatch('auth.login', form.values());
        if (!res.uuid) isOTP = true;

        dispatch(
          'ui.snackBar.open',
          !isOTP
            ? 'Login Successful.'
            : 'Check your email and enter the code you were sent.',
        );
        form.clear();
      } catch (err) {
        const errorMessage = /invalid|locked/i.test(err.message)
          ? err.message
          : 'An error occurred while attempting to log in';
        form.invalidate(errorMessage);
        dispatch('ui.snackBar.error', errorMessage);
      }
    },
  });

  setup() {
    return {
      fields: ['email', 'password'],
      labels: {
        email: 'Email',
        password: 'Password',
      },
      placeholders: {
        email: 'Email',
        password: 'Password',
      },
      rules: {
        email: 'required|email|string|between:5,50',
        password: 'required|between:5,40',
      },
    };
  }
}

export { AuthForm };
